import { Component, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { SimpleChanges } from '@angular/core/src/metadata/lifecycle_hooks';
import { Options } from 'ng5-slider';

@Component({
    selector: 'range-slider',
    templateUrl: './range-slider.component.html',
    styleUrls: ['./range-slider.component.scss']
})
export class RangeSliderComponent implements OnChanges {
    @Input() data: Array<number>;
    @Input() minValue: number;
    @Input() maxValue: number;
    @Input() options: Options = {
      floor: 0,
      ceil: 100
    };

    @Output() rangeValue: EventEmitter<any> = new EventEmitter();

    bars: number = 40;
    rangeCollection: { i: number, height: String, inRange: Boolean }[];
    rangesChunks: Array<number> = [];
    rangesHeight: Array<String> = [];

    constructor() {
      this.rangeCollection = Array.from({ length: this.bars }, (_, i) => ({ i, height: "0%", inRange: false }))
    }

    ngOnChanges(changes: SimpleChanges) {
      const { data } = changes;

      if (data && data.currentValue instanceof Array && data.currentValue.length) {
        
        const { min, max, step, chunks, ranges } = this.getRanges(data.currentValue)

        // Update min/max bounds
        this.options = {
          floor: min,
          ceil: max
        }

        // Select by default medium values
        if (this.minValue === undefined) {
          this.minValue = Math.floor(this.bars * 0.25 * step)
        }

        if (this.maxValue === undefined) {
          this.maxValue = Math.ceil(this.bars * 0.75 * step)
        }

        this.rangesHeight = ranges;
        this.rangesChunks = chunks;

        this.setRangesProperties()
      }
    }

    getRanges(values: any) {
      const parsedValues = values.map((val: any) => parseFloat(val))
      const max: number = Math.ceil(Math.max.apply(Math, parsedValues))
      const min: number = Math.floor(Math.min.apply(Math, parsedValues))

      const step: number = (max - min) / this.bars
      const arrayOfRanges: Array<number> = Array.from({ length: this.bars }, (_, i) => (i * step) + min)

      const getArrayPosition = (x: number) => arrayOfRanges.findIndex(range => range >= x)
      const arrayGroupedByRange: Array<number[]> = Array.from({ length: this.bars }, () => [])

      parsedValues.forEach((value: number) => {
        let indexInGroupedArray = getArrayPosition(value)
        
        if (indexInGroupedArray === -1) {
          indexInGroupedArray = arrayOfRanges.length - 1
        }

        arrayGroupedByRange[indexInGroupedArray] = (arrayGroupedByRange[indexInGroupedArray] || []).concat(value)
      })

      const rangesByLength = arrayGroupedByRange.map((range: number[]) => range.length)
      const rangesByPercent: string[] = rangesByLength.map((d: number) => `${(100 * d / Math.max.apply(Math, rangesByLength)) || 0}%`)

      const chunks = Array.from({ length: this.bars }, (_, i) => (step * i) + min)

      return {
        max, min, step, chunks, ranges: rangesByPercent
      }
    }

    setRangesProperties() {
      for (let index = 0; index < this.rangeCollection.length; index++) {
        this.rangeCollection[index].height = this.rangesHeight[index];
        this.rangeCollection[index].inRange = (this.minValue <= this.rangesChunks[index]) && (this.maxValue >= this.rangesChunks[index]);
      }
    }

    onSliderChange(event) {
      this.minValue = event.value;
      this.maxValue = event.highValue;

      this.setRangesProperties()

      this.rangeValue.emit({
        max: this.maxValue,
        min: this.minValue
      })
    }

    onInputMaxChange(value: number) {
      if (value) {
        this.maxValue = value;

        this.setRangesProperties()

        this.rangeValue.emit({
          max: this.maxValue,
          min: this.minValue
        })
      }
    }

    onInputMinChange(value: number) {
      if (value) {
        this.minValue = value;

        this.setRangesProperties()

        this.rangeValue.emit({
          max: this.maxValue,
          min: this.minValue
        })
      }
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/range-slider/range-slider.component.ts